import type { ReactNode } from 'react';

import { EmissionSticker1 } from '@gds/Icons/Paths/EmissionSticker1';
import { EmissionSticker2 } from '@gds/Icons/Paths/EmissionSticker2';
import { EmissionStickerE } from '@gds/Icons/Paths/EmissionStickerE';

const CERTIFICATES = [
  {
    id: 'E',
    label: 'E',
    renderLabel: (name: ReactNode) => (
      <>
        <EmissionStickerE /> {name}
      </>
    ),
    selected: false,
  },
  {
    id: '1',
    label: '1',
    renderLabel: (name: ReactNode) => (
      <>
        <EmissionSticker1 /> {name}
      </>
    ),
    selected: false,
  },
  {
    id: '2',
    label: '2',
    renderLabel: (name: ReactNode) => (
      <>
        <EmissionSticker2 /> {name}
      </>
    ),
    selected: false,
  },
];

export { CERTIFICATES };
